import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const TreeHeader = htmlE`<div class="table-responsive h-full list-table bg-primaryMain">
  <table class="table h-full is-fullwidth bg-primaryMain is-flex is-flex-direction-column">
    <thead>
      <tr class="is-flex">
      <th
          id="checkTh"
          class="is-cursor-pointer table-header is-flex is-justify-content-space-between is-align-items-center"
          style="width: 38px"
        >
        <label for="checkAll" class="is-sr-only">Select All</label>
          <input type="checkbox" id="checkAll" />
        </th>
        <th
            id="manage-shares-created-sort-list"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer is-clipped is-ellipsis table-header"
            style="width: 15%; min-width: 150px;"
            data-sort-key="created"
          >
            <span data-i18n-key="created" class="whitespace-nowrap">${"created"}</span>
          </th>

        <th
            id="manage-shares-expires-sort-list"
            style="width: 15%; min-width: 150px;"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
            data-sort-key="expires"
          >
            <span data-i18n-key="expires" class="whitespace-nowrap">${"expires"}</span>
          </th>

        <th
            id="manage-shares-to-sort-list"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
            style="width: 15%; min-width: 200px;"
            data-sort-key="to"
          >
            <span data-i18n-key="to" class="whitespace-nowrap">${"to"}</span>
        </th>

        <th
            id="manage-shares-remaining-sort-list"
            style="width: 15%; min-width: 300px;"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
            data-sort-key="paths"
          >
            <span data-i18n-key="paths" class="whitespace-nowrap"
              >${"paths"}</span
            >
        </th>

        <th
            id="manage-shares-remaining-sort-list"
            style="width: 15%; min-width: 200px;"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
            data-sort-key="remainingUses"
          >
            <span data-i18n-key="remainingUses" class="whitespace-nowrap"
              >${"remainingUses"}</span
            >
        </th>

        <th
            id="manage-shares-downloads-sort-list"
            style="width: 15%; min-width: 200px;"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
            data-sort-key="downloads"
          >
            <span data-i18n-key="Download" class="whitespace-nowrap"
              >${"downloads"}</span
            >
        </th>

        <th
            id="manage-shares-comments-sort-list"
            style="width: 15%; min-width: 100px;"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
            data-sort-key="comments"
          >
            <span data-i18n-key="comments" class="whitespace-nowrap"
              >${"comments"}</span
            >
          </th>
      </tr>
    </thead>
    <tbody class="table-body h-full" id="manage-shares-virtual-list"></tbody>
  </table>
</div>`;

const TreeItem = htmlE`
      <td style="width:38px;" class="table-td check-td">
        <input ${"checked"} class="checks manage-shares-list-checks is-cursor-pointer" type="checkbox" />
      </td>
      <td data-contextmenu-key="created" class="name-td table-td text-sm" style="width: 15%; min-width:150px;">
        <p class="w-full is-clipped is-ellipsis">${"created"}</p>
      </td>
      <td data-contextmenu-key="expires" class="path-td table-td text-sm" style="width: 15%; min-width: 150px;">
        <p class="w-full is-clipped is-ellipsis">${"expires"}</p>
      </td>
      <td data-contextmenu-key="emailTo" class="size-td table-td text-sm" style="width: 15%; min-width: 200px;">
        <p class="w-full is-clipped is-ellipsis">${"to"}</p>
      </td>
      <td data-contextmenu-key="paths" class="path-td table-td text-sm" style="width: 15%; min-width: 300px;">
        <p class="w-full is-clipped is-ellipsis">${"paths"}</p>
      </td>
      <td data-contextmenu-key="remainingUses" class="modified-td table-td text-sm" style="width: 15%; min-width: 200px;">
        <p class="w-full is-clipped is-ellipsis">${"remainingUses"}</p>
      </td>
      <td data-contextmenu-key="downloads" class="modified-td table-td text-sm" style="width: 15%; min-width: 200px;">
        <p class="w-full is-clipped is-ellipsis">${"downloads"}</p>
      </td>
      <td data-contextmenu-key="comments" class="created-td table-td text-sm" style="width: 15%; min-width: 100px;">
        <p class="w-full is-clipped is-ellipsis">${"comments"}</p>
      </td>`;

const ListingTemplates = {
  TreeHeader,
  TreeItem,
};

export default ListingTemplates;
